import DefaultNotification from "./DefaultNotification";

class ErrorNotification extends DefaultNotification {
    type = "danger";
}

export default ErrorNotification;